import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/navlayer/create/navlayer.create.mutation.gql"
import type {
  NavLayerCreateMutation,
  NavLayerCreateMutationVariables,
} from "@/v2-backoffice-client/navlayer/create/__types__/navlayer.create.mutation"

type Options = MutationHookOptions<
  NavLayerCreateMutation,
  NavLayerCreateMutationVariables
>

export function useNavLayerCreateMutation(options?: Options) {
  return useMutation<NavLayerCreateMutation, NavLayerCreateMutationVariables>(
    mutation,
    options,
  )
}
